module.exports = __webpack_public_path__ + "static/mark-9095bba4b848a05f524ac3cc0ffbde42.png";